import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  search: {
    padding: '10px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderBottom: '1px solid #E0E0E0',
    background: whiteColor,
    flexShrink: '0',
    '& .search-icon': {
      position: 'absolute',
      left: '11px',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '14px',
      color: '#808080',
      pointerEvents: 'none',
      lineHeight: 1,
    },
    '& .search-wrap': {
      flex: '1',
      maxWidth: '400px',
      position: 'relative',
    },
    '& .search-input': {
      width: '100%',
      padding: '7px 32px 7px 34px',
      fontSize: '13px',
      fontFamily: 'inherit',
      color: '#1F1F1F',
      background: '#F6F6F6',
      border: '1.5px solid #E0E0E0',
      borderRadius: '8px',
      outline: 'none',
      transition: 'border-color 120ms, box-shadow 120ms, background 120ms',
    },
  },
  table: {
    width: '100%',
    height: '100%',
  },
  headerWrapper: (props: {backgroundColorWithOpacity: string, statusColor: string}) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '& .change-log': {
      fontSize: '11px',
      fontWeight: '600',
      letterSpacing: '0.8px',
      textTransform: 'uppercase',
      color: '#6C59E6',
    },
    '& .unit-identity': {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    '& .unit-special': {
      fontSize: '22px',
      fontWeight: '700',
      color: '#2E2A66',
      letterSpacing: '-0.4px',
    },
    '& .unit-meta-chips': {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
    '& .historyChipBackground': {
      backgroundColor: props.backgroundColorWithOpacity,
    },
  }),
  wrapperContentHeader: (props: {backgroundColorWithOpacity: string, statusColor: string}) => ({
    padding: '20px 24px 18px',
    borderBottom: `1.5px solid ${props.statusColor}`,
    backgroundColor: '#F0EEFC',
  }),
  wrapperContent: {
    minHeight: '100%',
    padding: '0 0px 44px 0px',
    maxWidth: '1160px',
  },
}));
